<script>
export default {
    name: 'RepricingTest',
    data() {
        return {
            loading: false,
            form: {
                price: null,
                regular_price: null,
                new_price: null,
                percent: null
            },
            result: null,
            formRules: {
                price: [
                    { required: true, message: 'Le prix est requis', trigger: 'blur' },
                    { type: 'number', message: 'Le prix doit être un nombre', trigger: 'blur' }
                ],
                new_price: [
                    { required: true, message: 'Le nouveau prix est requis', trigger: 'blur' },
                    { type: 'number', message: 'Le nouveau prix doit être un nombre', trigger: 'blur' }
                ],
                percent: [
                    { required: true, message: 'Le pourcentage est requis', trigger: 'blur' },
                    { type: 'number', message: 'Le pourcentage doit être un nombre', trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        async calculate() {
            this.$refs.formRef.validate(async (valid) => {
                if (!valid) return false;

                this.loading = true;
                try {
                    const response = await axios.post('/repricing-test', this.form);
                    this.result = response.data.result;
                    this.$message.success('Calcul effectué avec succès');
                } catch (error) {
                    this.$message.error('Erreur lors du calcul');
                    console.error(error);
                } finally {
                    this.loading = false;
                }
            });
        },
        resetForm() {
            this.$refs.formRef.resetFields();
            this.result = null;
        }
    }
};
</script>

<template>
    <div v-loading="loading" class="repricing-test">
        <el-card shadow="never">
            <div slot="header" class="clearfix">
                <span class="header-title">Test de calcul ExtractRepricing</span>
            </div>

            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form
                        ref="formRef"
                        :model="form"
                        :rules="formRules"
                        label-width="180px">
                        <el-form-item label="Prix (price)" prop="price">
                            <el-input-number
                                v-model="form.price"
                                :min="0"
                                :precision="2"
                                :step="1"
                                placeholder="Ex: 100.00"
                                style="width: 100%">
                            </el-input-number>
                        </el-form-item>

                        <el-form-item label="Prix régulier (regular_price)" prop="regular_price">
                            <el-input-number
                                v-model="form.regular_price"
                                :min="0"
                                :precision="2"
                                :step="1"
                                placeholder="Ex: 120.00 (optionnel)"
                                style="width: 100%">
                            </el-input-number>
                            <span>Si 0 ou vide, le calcul utilisera le prix</span>
                        </el-form-item>

                        <el-form-item label="Nouveau prix (new_price)" prop="new_price">
                            <el-input-number
                                v-model="form.new_price"
                                :min="0"
                                :precision="2"
                                :step="1"
                                placeholder="Ex: 80.00"
                                style="width: 100%">
                            </el-input-number>
                        </el-form-item>

                        <el-form-item label="Pourcentage (%)" prop="percent">
                            <el-input-number
                                v-model="form.percent"
                                :max="100"
                                :min="0"
                                :precision="2"
                                :step="1"
                                placeholder="Ex: 15.00"
                                style="width: 100%">
                            </el-input-number>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" @click="calculate">
                                Calculer
                            </el-button>
                            <el-button @click="resetForm">
                                Réinitialiser
                            </el-button>
                        </el-form-item>
                    </el-form>
                </el-col>

                <el-col :span="12">
                    <div v-if="result" class="result-container">
                        <h3>Résultats</h3>
                        <el-descriptions :column="1" border>
                            <el-descriptions-item label="Remise totale">
                                <strong>{{ result.total_discount }}%</strong>
                            </el-descriptions-item>
                            <el-descriptions-item label="Code promo">
                                <strong>{{ result.promo_code }}%</strong>
                            </el-descriptions-item>
                            <el-descriptions-item label="Exclusion opé web">
                                <el-tag :type="result.feature_exclusion_op_web ? 'danger' : 'success'">
                                    {{ result.feature_exclusion_op_web ? 'Oui' : 'Non' }}
                                </el-tag>
                            </el-descriptions-item>
                            <el-descriptions-item label="Coefficient">
                                <strong>{{ result.coef ? result.coef.toFixed(6) : '0.000000' }}</strong>
                            </el-descriptions-item>
                            <el-descriptions-item label="Validation nouveau prix">
                                <strong>{{ result.validation_new_price }} €</strong>
                            </el-descriptions-item>
                            <el-descriptions-item label="Nouveau prix">
                                <strong>{{ result.new_price }} €</strong>
                            </el-descriptions-item>
                            <el-descriptions-item label="Date">
                                {{ result.date }}
                            </el-descriptions-item>
                        </el-descriptions>

                        <el-alert
                            v-if="Math.abs(result.validation_new_price - result.new_price) > 0.01"
                            :closable="false"
                            style="margin-top: 15px"
                            title="Attention : Le prix de validation ne correspond pas au nouveau prix !"
                            type="warning">
                        </el-alert>
                    </div>
                    <div v-else class="no-result">
                        <el-empty
                            description="Remplissez le formulaire et cliquez sur 'Calculer' pour voir les résultats"></el-empty>
                    </div>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>

<style lang="scss" scoped>
.repricing-test {
    .header-title {
        font-size: 16px;
        font-weight: 500;
    }

    .form-help {
        color: #909399;
        font-size: 12px;
    }

    .result-container {
        h3 {
            margin-top: 0;
            margin-bottom: 15px;
            color: #303133;
        }
    }

    .no-result {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 400px;
    }
}
</style>
